import { SCREENS } from '@core/assistant/interfaces';
import { debugTagName } from '@core/assistant/constants';

export const globals = {
  visualizerInstance: undefined as any,
  activeScreenGlob: SCREENS.DEFAULT as SCREENS,
  isMutedGlob: false,
  currentRegion: '',
  assistantGain: 1,
};

export const getCurrentRegion = (): string => {
  let currentArea = globals.currentRegion;
  if (!globals.currentRegion && debugTagName) {
    currentArea = debugTagName;
  }
  return currentArea;
};
